import React, { useEffect, useState } from 'react';
import "./myAvailability.scss";
import { getAvailability, submitAvailability } from "../../../actions/tutorFeedActions";
import { connect } from "react-redux";
import moment from "moment";

const MyAvailability = (props) => {
    const [leadsRequest, setleadsRequest] = useState([]);
    useEffect(() => {
        var LoginData = JSON.parse(localStorage.getItem("loginData"));
        props.getAvailability(LoginData.user.id)
            .then((res) => {
                setleadsRequest(res.data.result)
            })
            .catch((err) => {
                debugger;
            })
    }, [])

    const availableFunctionHit = (data) => {
        debugger;
        var LoginData = JSON.parse(localStorage.getItem("loginData"));
        props.submitAvailability(data.lead_id, LoginData.user.id, data.class_request_id)
        .then((res) => {
            window.location.reload();
        })
        .catch((err) => {
            
        })
    }
    console.log("Leads Request", leadsRequest);
    return (
        <div className="MyAvailability">
            <label className="font-weight-bold">Do you want to take any of these Demo Class?</label>
            <div className="row">
                {leadsRequest.length > 0 ? leadsRequest.map((item, index) =>
                    <div className="col-md-6">
                        <div className="availabilityCard">
                            <div className="row">
                                <div className="col-md-12">
                                    <p className="text-muted">{index + 1}. Are you available to take this demo class?</p>
                                    <br />
                                </div>
                                <div className="col-md-12">
                                    <i className="fas fa-chalkboard-teacher mr-3"></i><label>{item.prog_name}</label> <br />
                                    <i className="fas fa-calendar mr-3"></i>   <label className="font-weight-bold">{moment(item.class_time).format('dddd, MMMM Do YYYY')} </label> <br />
                                    <i className="fas fa-clock mr-3"></i>  <label className="font-weight-bold">{moment(item.class_time).format('LT')} </label>
                                </div>
                                {item.intereted === 1 ?
                                    <div className="col-md-12 mt-2">
                                        <button className="submittedBtn" disabled={true}>Request has been submitted</button>
                                    </div>
                                    :
                                    <div className="col-md-12 d-flex justify-content-between mt-2">
                                        <button className="intrestedBtn" onClick={() => availableFunctionHit(item)}>I am available</button>
                                        <button className="NotintrestedBtn">I am NOT available</button>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                )
                    :

                    <div className="col-md-12 text-center">
                        <div className="spinner-border text-dark text-center" role="status">
                            <span className="sr-only">Loading...</span>
                        </div>
                    </div>
                }

            </div>
        </div>
    );
}


export default connect(null, { getAvailability, submitAvailability })(MyAvailability);